import { SubscriptionBillingCycleEnum, SubscriptionPlanCategoryEnum } from "../enums/PartnerSubscription";
import { SubscriptionPlanInterface } from "../interfaces/payment/SubscrptionPlanInterface";

export const enterprisePlan: SubscriptionPlanInterface = {
    "id": 27,
    "externalId": "81f0baa8-b86a-n494a-a865-bbdb5c42c2b8", // this is hardcoded like in the backend and shouln't change
    "resetCycle": SubscriptionBillingCycleEnum.YEARLY,
    "unlocksPerResetCycle": 1000,
    "cvUnlocksPerResetCycle": 1200,
    "jobsPerResetCycle": 120,
    "jobOpenDurationDays": 30,
    "gracePeriodDays": 0,
    "monthlyBillingPrice": 12500,
    "yearlyBillingPrice": 12500,
    "category": SubscriptionPlanCategoryEnum.ENTERPRISE,
    "name": {
        "ar": "120 إعلان وظيفي",
        "en": "120 Job Post"
    },
    "description": {
        "ar": "120 إعلان وظيفي",
        "en": "120 Job Post"
    },
    "discount": null,
    "partnerWhoCanUsePlan": null,
    "excludedPaymentProcessors": [],
    "features": {
        "hasChat": true,
        "hasVideoCv": true,
        "hasJobPromotion": true,
        "hasAdvancedFilters": true
    },
    "isDiscountActive": false
}